import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Gallery.css';
import Navbar from './Navbar';
import ConsultationSection from './ConsultationSection';
import FooterSection from './FooterSection';
import img1 from '../assets/img/gallery/one.jpg';
// import img2 from '../assets/img/gallery/two.jpg';
// import img3 from '../assets/img/gallery/three.jpg';
// import img4 from '../assets/img/gallery/four.jpg';
// import img5 from '../assets/img/gallery/five.jpg';
import img6 from '../assets/img/gallery/six.jpg';
// import img7 from '../assets/img/gallery/seven.jpg';
import img8 from '../assets/img/gallery/eight.jpg';
import img9 from '../assets/img/gallery/nine.jpg';
import img10 from '../assets/img/gallery/ten.jpg';
import img11 from '../assets/img/gallery/eleven.jpg';
import img12 from '../assets/img/gallery/twelve.jpg';
import img13 from '../assets/img/gallery/thirteen.jpg';
import img14 from '../assets/img/gallery/fourteen.jpg';
import img15 from '../assets/img/gallery/fifteen.jpg';
import img16 from '../assets/img/gallery/sixteen.jpg';
import img17 from '../assets/img/gallery/seventeen.jpg';
import img18 from '../assets/img/gallery/eighteen.jpg';
import img19 from '../assets/img/gallery/nineteen.jpg';
import video20 from '../assets/img/gallery/twenty.mp4';
// import video21 from '../assets/img/gallery/twentyone.mp4';

const media = [
  { src: img1, title: 'Hon. Tribal & development Minister Shri Vijay Kumar Gavit' },
  { src: img10, title: 'Hon. Cheif Minister Eknath Shinde' },

  { src: img8, title: 'Former CM Prithviraj Chavan' },
  { src: img18, title: 'Former Revenue Minister Balasaheb Thorat' },
  { src: img9, title: 'K.P.G. Collage, Igatpuri -Breast Cancer Awarness' },
  { src: img11, title: 'Loknete Vyantarao Hiray College - Breast Cancer Awareness Program' },
  { src: img12, title: 'Loknete Vyantarao Hiray College - Breast Cancer Awareness Program' },
  { src: img13, title: 'Loknete Vyantarao Hiray College - Breast Cancer Awareness Program' },
  { src: img14, title: 'Rotary Club Nashik' },
  { src: img15, title: 'Rotary Club Nashik' },
  { src: img16, title: 'Rotary Club Nashik' },
  { src: img17, title: 'Prajapati Brahmakumari Head Aasha Didi' },
    { src: img6, title: 'Cancer Free Maha Campaign' },
  // { src: img19, title: 'Awareness Program' },
  { src: video20, title: 'Hon. Cheif Minister Eknath Shinde' },
  // { src: video21, title: 'Video 21' }
];

// Group media items by their title
const groupMediaByTitle = () => {
  const groups = {};

  media.forEach((item) => {
    const groupTitle = item.title?.trim() || 'Untitled';

    if (!groups[groupTitle]) {
      groups[groupTitle] = [];
    }
    groups[groupTitle].push(item);
  });

  return groups;
};

const Gallery = () => {
  const groupedMedia = groupMediaByTitle();

  return (
    <>
      <Navbar />
      <div className="gallery-page">
        <div className="container py-5">
          <h2 className="gallery-title text-center">Infrared Imaging Gallery</h2>
          <div className="why-thermal-line"></div>

          {Object.entries(groupedMedia).map(([sectionTitle, items], idx) => (
            <div key={idx} className="mb-5">
              <h3 className="section-heading mb-3">{sectionTitle}</h3>
              <div className="row g-4">
                {items.map((item, subIdx) => (
                  <div className="col-md-4" key={subIdx}>
                    <div className="gallery-card shadow-sm">
                      <div className="media-container">
                        {item.src.endsWith('.mp4') ? (
                          <video className="gallery-media" controls>
                            <source src={item.src} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img
                            src={item.src}
                            alt={item.title}
                            className="gallery-media"
                          />
                        )}
                        <div className="image-title">{item.title}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <ConsultationSection />
      <FooterSection />
    </>
  );
};

export default Gallery;
